import { z } from "zod";

export const BusinessUnitProductItemSchema = z.object({
  Id: z.string(),
  ProductId: z.string().optional(),
  ProductName: z.string().optional(),
});

export type GlobalBusinessUnitProductItemType = z.infer<
  typeof BusinessUnitProductItemSchema
>;
